import { SimpleMappedStorePresentation } from "@core/store/mappedStorePresentation";
import { SimpleStore } from "@core/store/store";
import { CurrentProfileService } from "@domain/currentProfile/currentProfileService";
import { Experience, ExperienceType } from "./experience";
import { ExperienceApi } from "./experienceApi";
import { ExperienceDraft } from "./experienceDraft";

export class ExperienceService {
	experienceStore = new SimpleStore((id) => this.experienceApi.get(id));
	userAcademicExperiencesStore = new SimpleMappedStorePresentation(this.experienceStore, (userId: string, page) =>
		this.experienceApi.getUserExperiences(userId, ExperienceType.ACADEMIC, page)
	);
	userProfessionalExperiencesStore = new SimpleMappedStorePresentation(this.experienceStore, (userId: string, page) =>
		this.experienceApi.getUserExperiences(userId, ExperienceType.PROFESSIONAL, page)
	);

	constructor(
		private readonly experienceApi: ExperienceApi,
		private readonly currentProfileService: CurrentProfileService
	) {}

	async delete(id: string, type: ExperienceType): Promise<void> {
		await this.experienceApi.delete(id);
		this.experienceStore.remove(id);
		this.fetchUserStore(type);
	}

	async saveExperience(draft: ExperienceDraft, id?: string): Promise<Experience> {
		const experience = await (id ? this.experienceApi.save(draft, id) : this.experienceApi.create(draft));
		this.experienceStore.save(experience);
		this.fetchUserStore(draft.type);
		return experience;
	}

	private fetchUserStore(type: ExperienceType): void {
		const currentProfile = this.currentProfileService.currentProfile.get();
		if (currentProfile) {
			const userStore =
				type === ExperienceType.ACADEMIC ? this.userAcademicExperiencesStore : this.userProfessionalExperiencesStore;
			userStore.fetch(currentProfile.id);
		}
	}
}
